export default __webpack_public_path__ + "static/media/background3.0e94f6a6.jpeg";